import mapCsConnectionToArray from '../csConnectionToArray';

const mapRegisterPage = (data) => {
  const { title, url, cta, disclaimer, imageConnection, offer, terms } = data;
  const mappedImageConnection = mapCsConnectionToArray(imageConnection)[0];

  return {
    cta,
    disclaimer,
    image: {
      src: mappedImageConnection.url
    },
    offer,
    terms,
    title,
    url,
  };
};

export default mapRegisterPage;
